<template>
  <div>
    <UpcomingCourses :data="data" />
    <Lazy :on-interaction="['click', 'touchstart']">
      <StartLearningToday
        v-if="$config.project !== 'lms'" class="start-learn-today" class-name="upcoming"
        unique-id="start-learning-today"
      >
        <p class="h2">
          {{ $c.text('component.start-learning-today.title') }}
        </p>
        <p class="h6">
          {{ $c.text('component.start-learning-today.description') }}
        </p>
        <p v-for="check in checks" :key="check" class="h6 check">
          <IconCheck /> {{ check }}
        </p>
      </StartLearningToday>
    </Lazy>
  </div>
</template>

<script>
import Lazy from 'vue-lazy-hydration';
import UpcomingCourses from '@itbpbg/lms-components/src/Upcoming-courses/Index';
import StartLearningToday from '../../components/StartLearningToday';
import IconCheck from '../../assets/svg/icon-check.svg?vue-component';

export default {
  components: {
    Lazy, UpcomingCourses, StartLearningToday, IconCheck,
  },
  layout: 'default',
  async asyncData({ $axios, route, redirect }) {
    const [upcommingCourses, page] = await Promise.all([
      $axios.$get('/upcoming-courses'),
      $axios.$get(`/pages/${route.fullPath}`),
    ]);
    if (upcommingCourses.courses && !upcommingCourses.courses.length) {
      redirect('/courses/');
    }

    return { data: { ...upcommingCourses, page } };
  },
  data() {
    return {
      checks: [
        'World-class instructors',
        'Exams testing your knowledge',
        'High-quality data science courses',
        'Certificate of achievement',
        'Motivational features based on game design',
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.start-learn-today {
  * {
    color: var(--main-light);
    margin: 0;
  }

  .h6 {
    margin: var(--spacing-24) 0 var(--spacing-36) 0;
    font-weight: normal;
    font-size: 18px;
    line-height: 150%;
  }

  .check {
    margin-top: 0;
    margin-bottom: var(--spacing-24);

    &:last-of-type {
      margin-bottom: 0;
    }

    svg {
      width: 18px;
      margin-right: 14px;
    }
  }
}

.fa {
  .start-learn-today .check {
    svg path[fill] {
      fill: var(--accent-light-3);
    }
  }
}
</style>
